module.exports = __webpack_public_path__ + "static/media/SostenibilitàSistemica_ASSETS-Fish_19.9a31ec98.png";